import Graphs from '../Graphs';
import { scaleLinear, scaleBand } from 'd3-scale';
import { max, range } from 'd3-array';
import { select } from 'd3-selection';
import { transition } from 'd3-transition';
import './GraphChart.css';

export default class GraphChart extends Graphs {
  renderChart = () => {
    const node = this.node;
    const dataMax = max(this.props.data);
    const padding = 20;
    global.transition = transition;

    const yScale = scaleLinear()
      .domain([0, dataMax])
      .range([this.props.size[1] - padding, padding]);

    const xScale = scaleBand()
      .domain(range(this.props.data.length))
      .rangeRound([0, this.props.size[0] - padding])
      .padding(0.1);

    select(node)
      .selectAll('rect')
      .data(this.props.data)
      .enter()
      .append('rect');

    select(node)
      .selectAll('rect')
      .data(this.props.data)
      .exit()
      .remove();

    select(node)
      .selectAll('rect')
      .data(this.props.data)
      .style('fill', "#333")
      .style('rx', '1%')
      .style('ry', '1%')
      .attr('x', (d, i) => xScale(i) + padding)
      .attr('y', d => yScale(d))
      .attr('width', xScale.bandwidth())
      .transition()
      .delay((d, i) => i / this.props.data.length * 1000)
      .duration(500)
      .attr('height', d => yScale(0) - yScale(d));
  }
}



// WEBPACK FOOTER //
// ./src/components/Graphs/GraphChartComponent/GraphChart.js